// src/services/authService.js
import axios from "axios";
import { toast } from "react-toastify";

class AuthService {
  // Função para lidar com o logout
  logout = () => {
    // Remover todos os dados de autenticação e estado do localStorage
    localStorage.removeItem("auth");
    localStorage.removeItem("projeto");
    localStorage.removeItem("projetos");
    localStorage.removeItem("report");
    localStorage.removeItem("dash_stages");

    // Remover o token de autorização do cabeçalho do Axios
    delete axios.defaults.headers.common["Authorization"];

    // Exibir uma notificação de sucesso
    toast.success("Você foi desconectado com sucesso.");

    // Recarregar a página para aplicar as alterações
    window.location.reload();
  };

  // Função para lidar com logout por expiração de sessão
  sessionExpiredLogout = () => {
    // Remover todos os dados de autenticação e estado do localStorage
    localStorage.removeItem("auth");
    localStorage.removeItem("projeto");
    localStorage.removeItem("projetos");
    localStorage.removeItem("report");
    localStorage.removeItem("dash_stages");

    // Remover o token de autorização do cabeçalho do Axios
    delete axios.defaults.headers.common["Authorization"];

    // Exibir uma notificação informando sobre a expiração da sessão
    toast.info("Sua sessão expirou. Por favor, faça login novamente.");

    // Recarregar a página para aplicar as alterações
    window.location.reload();
  };

  // Configurar interceptor de resposta do Axios para tratar erros de autenticação
  setupAxiosInterceptors = () => {
    axios.interceptors.response.use(
      (response) => {
        // Se houver um novo token no cabeçalho da resposta, atualizar no localStorage
        const newToken = response.headers.authorization;
        if (newToken && newToken.startsWith("Bearer ")) {
          const token = newToken.split(" ")[1];
          const authData = JSON.parse(localStorage.getItem("auth")) || {};
          authData.auth_token = token;
          localStorage.setItem("auth", JSON.stringify(authData));
          axios.defaults.headers.common["Authorization"] = newToken;
        }
        return response;
      },
      (error) => {
        // Verificar se o erro é de autenticação (401)
        if (error.response && error.response.status === 401) {
          // Verificar se a mensagem de erro indica token expirado
          const errorMessage = error.response.data?.error?.toLowerCase() || "";
          if (
            errorMessage.includes("expirado") ||
            errorMessage.includes("token inválido")
          ) {
            this.sessionExpiredLogout();
          }
        }
        return Promise.reject(error);
      }
    );
  };

  // Função para verificar se o token está expirado (usando apenas o frontend)
  checkTokenExpiration = () => {
    try {
      const authData = JSON.parse(localStorage.getItem("auth")) || {};
      const token = authData.auth_token;

      if (!token) return false;

      // Decodificar o token (sem verificar a assinatura, apenas para acessar o payload)
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const payload = JSON.parse(window.atob(base64));

      // Verificar o tempo de expiração
      const expirationTime = payload.exp * 1000; // converter para milissegundos
      const currentTime = Date.now();

      // Se o token está próximo da expiração (menos de 5 minutos), podemos tentar renovar
      if (expirationTime - currentTime < 300000) {
        return true;
      }

      return false;
    } catch (error) {
      console.error("Erro ao verificar expiração do token:", error);
      return true; // Se houver erro na verificação, considerar como expirado por segurança
    }
  };
}

export default new AuthService();
